import type { Box } from "@/components/ui/box.schema";
import { BriefMaterials } from "./BriefMaterials";
import type { ShownMaterial } from "./brief-materials";

/**
 * A learner's hand-in box with the brief's course materials beside its
 * instructions (ADR 0039, 2026-11-03). The box stays the shared hand-in work's
 * own: the references join its brief part, or follow a settled read's body.
 */
export function withBriefMaterials(box: Box, materials: ShownMaterial[] | undefined): Box {
  if (!materials?.length) return box;
  const shown = <BriefMaterials materials={materials} />;
  if (box.kind === "task" && box.parts.some(part => ["brief", "rules"].includes(part.id) && part.render)) {
    return { ...box, parts: box.parts.map(part => {
      const render = part.render;
      return ["brief", "rules"].includes(part.id) && render ? { ...part, render: () => <>{render()}{shown}</> } : part;
    }) };
  }
  if (box.kind === "fact" && box.body) {
    const body = box.body;
    return { ...box, body: value => <div className="grid gap-4">{body(value)}{shown}</div> };
  }
  return box;
}
